/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/styles';
import { CircularProgress, Grid } from '@material-ui/core';
import axios from 'axios';
import _ from 'lodash';
import styles from './styles';
import DetailView from './components/DetailView';
import ListView from './components/ListView';
import {
  API_KEY_JOBS,
  PENDING_PHOTOS_APIS,
  APPROVE_IMAGE,
  SEARCH_API,
  API_KEY_ACCOUNTS,
} from '../../constants';

const PhotoAwaitingApproval = ({ classes, setBuilder }) => {
  const [selectedBuilder, setSelectedBuilder] = useState();
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  // eslint-disable-next-line no-unused-vars

  const fetchData = async () => {
    setLoading(true);
    const data = await getPendingPhotos();
    setUsers(data);
    if (selectedBuilder) {
      setSelectedBuilder(
        data.filter(user => user.id === selectedBuilder.id)[0],
      );
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className={classes.inputDiv}>
      <div className={classes.heading}>PHOTOS AWAITING APPROVAL</div>
      <div className={classes.tableContainer}>
        <Grid container>
          {/* <Grid xs={12} justify="center" className={classes.nameContainter}> */}

          {selectedBuilder && (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <span
              className={classes.cross}
              onClick={() => {
                setSelectedBuilder(null);
              }}
            >
              X
            </span>
          )}

          {/* </Grid> */}
          <Grid container justify="center">
            {loading && <CircularProgress size={40} />}

            {!selectedBuilder ? (
              <ListView
                loading={loading}
                users={users}
                setBuilder={async builder => {
                  console.log('Builder Sel', builder);
                  setLoading(true);
                  const builderFromAccounts = await searchApi(builder.email);
                  setLoading(false);

                  setBuilder({ ...builderFromAccounts, ...builder });
                }}
                setSelectedBuilder={builder => {
                  setSelectedBuilder(builder);
                }}
              />
            ) : (
              <DetailView
                loading={loading}
                builder={selectedBuilder}
                acceptImages={async imageIds => {
                  await acceptRejectImages(imageIds, true);
                  fetchData();
                }}
                rejectImages={async imageIds => {
                  await acceptRejectImages(imageIds, false);
                  fetchData();
                }}
              />
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

const acceptRejectImages = async (imageIds, approve) => {
  const token = localStorage.getItem('accessToken');
  try {
    const promises = imageIds.map(id =>
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': `${API_KEY_JOBS}`,
          Authorization: `Bearer ${token}`,
        },
        url: `${APPROVE_IMAGE}`,
        data: {
          fileId: id,
          approve,
        },
        validateStatus(status) {
          return status === 200; // default
        },
      }),
    );
    const response = await Promise.all(promises);
    console.log(response);
    return response;
  } catch (err) {
    throw err;
  }
};

const getPendingPhotos = async () => {
  const token = localStorage.getItem('accessToken');
  try {
    const response = await axios({
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${API_KEY_JOBS}`,
        Authorization: `Bearer ${token}`,
      },
      url: `${PENDING_PHOTOS_APIS}?status=0`,
      validateStatus(status) {
        return status === 200; // default
      },
    });

    return response.data;
  } catch (err) {
    throw err;
  }
};

const searchApi = async searchQuery => {
  const token = localStorage.getItem('accessToken');
  try {
    const emailSearchResponse = await axios({
      method: 'get',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': `${API_KEY_ACCOUNTS}`,
        Authorization: `Bearer ${token}`,
      },
      url: `${SEARCH_API}?email=${encodeURIComponent(searchQuery)}`,
      validateStatus(status) {
        return status === 200; // default
      },
    });
    console.log('emailSearc', emailSearchResponse);

    return _.get(emailSearchResponse, 'data.results.0', {});
  } catch (err) {
    throw err;
  }
};
export default withStyles(styles)(PhotoAwaitingApproval);
